module.exports = __webpack_public_path__ + "img/auth.0aa476ca.svg";